import NotFoundComponent from "./reusable/NotFoundComponent";

const NotFound = () => {
  return <NotFoundComponent message={"Oops! page not found"} />;
};

export default NotFound;
